module.exports = __webpack_public_path__ + "img/1F1ED-1F1F0.81489ffc.svg";